import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { addError } from 'actions';
import { submit_post, update_post, deletePostFile } from 'actions/posts';
import { getMentorGroups, getSection, getSections } from 'actions/sections';
import moment from 'moment';
import User from '_class/User';
import GroupUserSelect from 'components/List/GroupUserSelect';
import UserSelect from 'components/List/UserSelect';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import DropzoneComponent from 'react-dropzone-component';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import { Expandable, List, Spinner } from 'UI';
import { withRouter } from 'react-router-dom';
import { Button, Checkbox, Radio, Icon, translate } from '@haldor/ui';
import { Close, Image } from 'UI/Icons';
import { Editor } from 'UI/Inputs';
import DatePickerEvent from './Partials/DatePickerEvent';
import swal from 'sweetalert2';
import FileItem from 'components/FileItem';
import getEnvironment from 'lib/env';
import { getToken, loginRequest, http } from 'lib/msal';

var Post = /*#__PURE__*/function (_Component) {
  _inherits(Post, _Component);

  var _super = _createSuper(Post);

  function Post(props) {
    var _this;

    _classCallCheck(this, Post);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "required", function (value) {
      if (value != null && value !== '') {
        if (value.length > 199) {
          // Field failed validation, return error for this field (String)
          return _this.props.translate('field-max-200-chars');
        } // Field passes validation, return a undefined error for this field
        // Rule: Not undefined and not an empty string and not over 200 characters


        return undefined;
      } // Field failed validation, return error for this field (String)


      return _this.props.translate('field-needs-input');
    });

    _defineProperty(_assertThisInitialized(_this), "quillValidation", function (value) {
      var strValue = value;
      var text = '';

      if (typeof strValue == 'string') {
        text = strValue.replace(/<(?:.|\n)*?>/gm, '');
      }

      if (text == "" || text == null) {
        return _this.props.translate('needs-description');
      }

      return undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "validateRelationships", function (value) {
      if (value == null || value == '') {
        return _this.props.translate('select-relation-error');
      }

      if (value.length == 0) {
        return _this.props.translate('select-relation-error');
      }

      return undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var promises = [];
      var user = new User(_this.props.currentUser);

      if ((user.isMentor() || user.isSchoolLeader() || user.isAdministrator()) && _this.props.mentorGroups.length == 0) {
        var mentorPromise = _this.props.getMentorGroups();

        promises.push(mentorPromise);
      }

      if (_this.props.sections == null) {
        var sectionPromise = _this.props.getSections();

        promises.push(sectionPromise);
      }

      if (promises.length > 0) {
        _this.setState({
          loading: true
        });
      }

      Promise.all(promises).then(function () {
        _this.setState({
          loading: false
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onCancel", function (event) {
      event.preventDefault();

      if (_this.props.onModalClose) {
        _this.props.onModalClose();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "submit", function (values) {
      return new Promise(function (resolve, reject) {
        if (values.relationships == null) {
          _this.setState({
            error: _this.props.translate('select-relation-error') + '!'
          });

          reject(0);
          return false;
        }

        var activePost = _this.props.activePost;
        var isEditing = activePost != null && Object.keys(activePost).length > 0;
        var user = new User(_this.props.currentUser);

        if (_this.dropzone && _this.dropzone.getQueuedFiles().length > 0) {
          _this.dropzone.on('totaluploadprogress', function (progress) {
            _this.setState({
              uploadProgress: progress
            });
          });

          var that = _assertThisInitialized(_this);

          _this.readyForSubmit(values).then(function (data) {
            var url = "".concat(http.defaults.baseURL, "posts/").concat(data, "/files?schoolId=").concat(user.getActiveSchool().id);

            if (isEditing) {
              url = "".concat(http.defaults.baseURL, "posts/").concat(activePost.id, "/files?schoolId=").concat(user.getActiveSchool().id);
            }

            _this.componentConfig.postUrl = url;
            _this.dropzone.options.url = url;

            _this.dropzone.processQueue();

            _this.dropzone.on("queuecomplete", function () {
              if (isEditing) {
                if (that.props.onModalClose) {
                  that.props.onModalClose(true, true);
                }
              } else {
                _this.props.history.push("/post/".concat(data));
              }

              resolve(data);
            });
          });
        } else {
          var _that = _assertThisInitialized(_this);

          _this.readyForSubmit(values).then(function (data) {
            if (isEditing) {
              if (_that.props.onModalClose) {
                _that.props.onModalClose(true, true);
              }
            } else {
              _this.props.history.push("/post/".concat(data));
            }

            resolve(data);
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "readyForSubmit", function (values) {
      return new Promise(function (resolve, reject) {
        var _this$state = _this.state,
            removedFiles = _this$state.removedFiles,
            dateStart = _this$state.dateStart,
            dateEnd = _this$state.dateEnd,
            published = _this$state.published,
            important = _this$state.important;
        var _this$props = _this.props,
            submit_post = _this$props.submit_post,
            update_post = _this$props.update_post,
            activePost = _this$props.activePost;
        var isEditing = activePost != null && Object.keys(activePost).length > 1;
        /* Add custom inputs to the values object that redux form creates */

        values.eventDate = dateStart;
        values.validUntil = dateEnd;
        values.published = published;
        values.important = important;
        values.targetAudience = '';

        if (values.targetStudents) {
          values.targetAudience += 'STUDENTS:';
        }

        if (values.targetGuardians) {
          values.targetAudience += 'GUARDIANS:';
        }

        if (values.targetGuardians && values.targetStudents) {
          values.targetAudience = 'ALL';
        }

        if (values.targetAudience[values.targetAudience.length - 1] == ':') {
          values.targetAudience.substring(0, values.targetAudience.length - 1);
        }

        if (values.status == null) {
          values.status = 'POST_PUBLISHED';
        } // Remove internal form properties from data


        delete values.targetGuardians;
        delete values.targetStudents;

        if (values.sender != null) {
          if (values.sender == 'me') {
            values.author = null;
          }

          delete values.sender;
        } // Convert dates to UTC


        values.published = moment(values.published).utc().format();

        if (values.eventDate != null) {
          values.eventDate = moment(values.eventDate).utc().format();
        }

        if (values.validUntil != null) {
          values.validUntil = moment(values.validUntil).utc().format();
        }

        if (isEditing) {
          if (removedFiles.length > 0) {
            removedFiles.map(function (file) {
              _this.props.deletePostFile(values.id, file.id);
            });
          } // Clear out the "files" object with fetched files to save data


          values.files = null; // Do NOT send the file src in the PUT request

          update_post(values, function (data) {
            resolve(data);
          });
        } else {
          submit_post(values).then(function () {
            resolve(_this.props.createdPost.id);
          });
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onDateChange", function (dates) {
      if (dates.start == "Invalid date") {
        dates.start = null;
      }

      if (dates.end == "Invalid date") {
        dates.end = null;
      }

      if (dates.published == "Invalid date") {
        dates.published = null;
      }

      _this.setState({
        dateStart: dates.start,
        dateEnd: dates.end,
        published: dates.published
      });
    });

    _defineProperty(_assertThisInitialized(_this), "dropzoneInit", function (dropzone) {
      _this.dropzone = dropzone;
    });

    _defineProperty(_assertThisInitialized(_this), "onAddFile", function (file) {
      var Files = _this.state.Files;

      if (file.size > 101000024) {
        _this.dropzone.removeFile(file); // File over 100MB


        swal.fire({
          title: _this.props.translate('file-too-big'),
          showCancelButton: false,
          confirmButtonText: _this.props.translate('okey')
        });
        return false;
      }

      Files.push(file);
      setTimeout(function () {
        _this.setState({
          Files: Files
        });
      }, 40);
    });

    _defineProperty(_assertThisInitialized(_this), "onRemoveFile", function (file) {
      var Files = _this.state.Files;
      var fileIndex = Files.findIndex(function (f) {
        return f.upload.filename === file.upload.filename;
      });
      Files.splice(fileIndex, 1);

      _this.setState({
        Files: Files
      }, function () {
        if (_this.dropzone) {
          _this.dropzone.removeFile(file);
        }
      });
    });

    _defineProperty(_assertThisInitialized(_this), "removeFileFromDocument", function (file) {
      var _this$state2 = _this.state,
          uploadedFiles = _this$state2.uploadedFiles,
          removedFiles = _this$state2.removedFiles;

      if (file != null) {
        var filesIndex = uploadedFiles.findIndex(function (f) {
          return f.id === file.id;
        });
        var fileObject = uploadedFiles[filesIndex];
        uploadedFiles.splice(filesIndex, 1);
        removedFiles.push(fileObject);

        _this.setState({
          uploadedFiles: uploadedFiles,
          removedFiles: removedFiles
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "importantToggle", function (checked) {
      _this.setState({
        important: checked
      });
    });

    _defineProperty(_assertThisInitialized(_this), "renderInput", function (_ref) {
      var input = _ref.input,
          label = _ref.label,
          placeholder = _ref.placeholder,
          _ref$meta = _ref.meta,
          touched = _ref$meta.touched,
          error = _ref$meta.error,
          warning = _ref$meta.warning;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("input", _extends({}, input, {
        placeholder: placeholder || label,
        style: touched && error ? {
          border: '1px solid red'
        } : {}
      })), touched && (error && /*#__PURE__*/React.createElement("span", {
        className: "error"
      }, error) || warning && /*#__PURE__*/React.createElement("span", {
        className: "error"
      }, warning)));
    });

    _defineProperty(_assertThisInitialized(_this), "renderTextarea", function (_ref2) {
      var input = _ref2.input,
          label = _ref2.label,
          type = _ref2.type,
          placeholder = _ref2.placeholder,
          _ref2$meta = _ref2.meta,
          touched = _ref2$meta.touched,
          error = _ref2$meta.error,
          warning = _ref2$meta.warning;
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("textarea", _extends({
        placeholder: placeholder || label,
        type: type
      }, input), input.value), touched && (error && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: '1rem'
        }
      }, error) || warning && /*#__PURE__*/React.createElement("span", {
        style: {
          marginTop: '1rem'
        }
      }, warning)));
    });

    _defineProperty(_assertThisInitialized(_this), "triggerDropzone", function () {
      if (_this.dropzone != null) {
        _this.dropzone.hiddenFileInput.click();
      }
    });

    var _uploadedFiles = [];

    if (props.activePost != null && props.activePost.associatedFiles != null) {
      _uploadedFiles = props.activePost.associatedFiles;
    }

    _this.state = {
      Files: [],
      uploadedFiles: _uploadedFiles,
      removedFiles: [],
      important: props.activePost != null ? props.activePost.important : false,
      dateStart: null,
      dateEnd: null,
      published: null,
      error: null,
      uploadProgress: null
    };
    _this.dropzone = null;
    /* Configure dropzone component */

    _this.componentConfig = {
      iconFiletypes: ['.jpg', '.png', '.gif'],
      showFiletypeIcon: false,
      postUrl: http.defaults.baseURL + 'fileItems',
      dropzoneSelector: '.dropzone-trigger'
    };
    _this.djsConfig = {
      autoProcessQueue: false,
      parallelUploads: 1,
      timeout: 99900000,
      headers: {}
    };
    var request = loginRequest;
    request.scopes = [].concat(_toConsumableArray(getEnvironment().scopes), _toConsumableArray(request.scopes));
    getToken(request).then(function (response) {
      _this.djsConfig.headers['Authorization'] = 'Bearer ' + response.accessToken;
    });
    _this.dropzoneEvents = {
      init: _this.dropzoneInit,
      addedfile: _this.onAddFile,
      success: function success() {
        _this.dropzone.processQueue();
      }
    };
    return _this;
  }
  /* Redux form functions */


  _createClass(Post, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var sections = [];
      var initialValues = JSON.parse(JSON.stringify(this.props.activePost));
      var isEditing = initialValues != null && initialValues.id != null;

      if (initialValues == null) {
        initialValues = {};
      }

      if (isEditing) {
        var _initialValues = initialValues,
            targetAudience = _initialValues.targetAudience,
            author = _initialValues.author;
        var currentUser = this.props.currentUser;
        initialValues.targetStudents = targetAudience == 'ALL' || (targetAudience === null || targetAudience === void 0 ? void 0 : targetAudience.indexOf('STUDENTS')) > -1;
        initialValues.targetGuardians = targetAudience == 'ALL' || (targetAudience === null || targetAudience === void 0 ? void 0 : targetAudience.indexOf('GUARDIANS')) > -1;
        initialValues.sender = author == currentUser.firstName + ' ' + currentUser.lastName ? 'me' : 'custom';
      } else {
        initialValues.targetStudents = true;
        initialValues.targetGuardians = true;
        initialValues.sender = 'me';
      }

      var user = new User(this.props.currentUser);

      if (user.isMentor() || user.isSchoolLeader() || user.isAdministrator()) {
        sections = this.props.sections.concat(this.props.mentorGroups);
      } else {
        sections = this.props.sections;
      }

      if (!(user.isSchoolLeader() || user.isAdministrator())) {
        // Only show groups user is owner for
        sections = sections.filter(function (section) {
          return section.userRole === "OWNER";
        });
      }

      if (this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }
      /* Validate group selection */


      var passingGroup = true;
      return /*#__PURE__*/React.createElement("div", {
        className: "form-container"
      }, /*#__PURE__*/React.createElement(Form, {
        onSubmit: this.submit,
        mutators: {
          setStatusDraft: function setStatusDraft(args, state, utils) {
            utils.changeValue(state, 'status', function () {
              return 'POST_DRAFT';
            });
          },
          setStatusPublished: function setStatusPublished(args, state, utils) {
            utils.changeValue(state, 'status', function () {
              return 'POST_PUBLISHED';
            });
          }
        },
        initialValues: initialValues,
        initialValuesEqual: function initialValuesEqual() {
          return true;
        },
        render: function render(_ref3) {
          var _form$getFieldState;

          var handleSubmit = _ref3.handleSubmit,
              form = _ref3.form,
              valid = _ref3.valid,
              submitting = _ref3.submitting,
              initialValues = _ref3.initialValues;
          var _this2$state = _this2.state,
              Files = _this2$state.Files,
              uploadedFiles = _this2$state.uploadedFiles,
              important = _this2$state.important;
          return /*#__PURE__*/React.createElement("form", {
            onSubmit: handleSubmit,
            className: "form form-component"
          }, submitting ? /*#__PURE__*/React.createElement("div", {
            className: "is_sending"
          }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", {
            className: "loading-spinner"
          }), /*#__PURE__*/React.createElement("br", null), _this2.state.uploadProgress != null ? /*#__PURE__*/React.createElement("div", {
            className: "upload-progress"
          }, /*#__PURE__*/React.createElement("div", {
            style: {
              width: Math.round(_this2.state.uploadProgress) + '%'
            },
            className: "upload-progress-bar"
          })) : null)) : null, /*#__PURE__*/React.createElement(Expandable, {
            contentStyles: {
              padding: '1em 0rem'
            },
            contentStylesClosed: {
              padding: '0'
            },
            headerStyles: _this2.state.error != null ? {
              border: '1px solid red'
            } : {},
            whiteBackground: true,
            title: user.getActiveSchool().type == 'PRESCHOOL' ? _this2.props.translate('groups-and-children') + '*' : _this2.props.translate('students') + '*',
            open: !isEditing,
            ignorePropsUpdate: true
          }, _this2.props.section != null ? /*#__PURE__*/React.createElement(List, {
            style: {
              border: '0',
              margin: '0',
              boxShadow: 'none'
            }
          }, /*#__PURE__*/React.createElement(Field, {
            component: GroupUserSelect,
            name: "relationships",
            section: _this2.props.section,
            validate: _this2.validateRelationships
          })) : /*#__PURE__*/React.createElement(List, {
            style: {
              border: '0',
              margin: '0',
              boxShadow: 'none'
            }
          }, /*#__PURE__*/React.createElement(Field, {
            component: UserSelect,
            name: "relationships",
            sections: sections,
            userSelectDisabled: false,
            selectMultipleSchools: _this2.props.selectMultipleSchools,
            showUsersWithoutMentorGroups: true,
            validate: _this2.validateRelationships
          }))), /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('select-recipient')), /*#__PURE__*/React.createElement("div", {
            style: {
              display: 'inline-block'
            }
          }, /*#__PURE__*/React.createElement(Field, {
            name: "targetGuardians",
            component: Checkbox,
            label: _this2.props.translate('Guardians')
          })), /*#__PURE__*/React.createElement("div", {
            style: {
              marginLeft: '1.25rem',
              display: 'inline-block'
            }
          }, /*#__PURE__*/React.createElement(Field, {
            name: "targetStudents",
            component: Checkbox,
            label: _this2.props.translate('students')
          })), /*#__PURE__*/React.createElement("div", {
            className: "size-12 color--meta recipient-alert"
          }, /*#__PURE__*/React.createElement(Icon, {
            name: "Alert",
            bw: true
          }), " ", _this2.props.translate('Posts will always be displayed for staff belonging to the groups you have selected.'))), /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('Sender')), /*#__PURE__*/React.createElement("div", {
            style: {
              display: 'inline-block'
            }
          }, /*#__PURE__*/React.createElement(Field, {
            component: Radio,
            name: "sender",
            label: _this2.props.currentUser.firstName + ' ' + _this2.props.currentUser.lastName,
            optionValue: "me"
          })), /*#__PURE__*/React.createElement("div", {
            style: {
              display: 'inline-block',
              marginLeft: '.85rem'
            }
          }, /*#__PURE__*/React.createElement(Field, {
            component: Radio,
            name: "sender",
            optionValue: "custom",
            label: _this2.props.translate('Free text') + (_this2.props.senderValue == 'custom' ? '*' : '')
          }))), ((_form$getFieldState = form.getFieldState('sender')) === null || _form$getFieldState === void 0 ? void 0 : _form$getFieldState.value) == 'custom' ? /*#__PURE__*/React.createElement("div", {
            className: "form-row",
            style: {
              marginTop: '.35rem'
            }
          }, /*#__PURE__*/React.createElement(Field, {
            name: "author",
            type: "text",
            component: _this2.renderInput,
            validate: _this2.required
          })) : null, _this2.state.error != null ? /*#__PURE__*/React.createElement("div", {
            className: "form-row error"
          }, _this2.state.error) : null, /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('title'), "*"), /*#__PURE__*/React.createElement(Field, {
            name: "title",
            type: "text",
            component: _this2.renderInput,
            placeholder: _this2.props.translate('title'),
            validate: _this2.required
          })), /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('description'), "*"), /*#__PURE__*/React.createElement(Field, {
            component: Editor,
            name: "body",
            validate: _this2.quillValidation,
            placeholder: _this2.props.translate('description'),
            translate: _this2.props.translate
          })), /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('add-images-and-files')), /*#__PURE__*/React.createElement("div", {
            className: "dropzone-trigger icon-container",
            style: {
              height: 'auto',
              width: '100%'
            }
          }, /*#__PURE__*/React.createElement("div", {
            onClick: _this2.triggerDropzone,
            className: "icon"
          }, /*#__PURE__*/React.createElement(Image, null)), /*#__PURE__*/React.createElement("div", {
            className: "text",
            onClick: _this2.triggerDropzone
          }, _this2.props.translate('drop-files-or-click-here')), /*#__PURE__*/React.createElement(DropzoneComponent, {
            djsConfig: _this2.djsConfig,
            eventHandlers: _this2.dropzoneEvents,
            config: _this2.componentConfig
          })), /*#__PURE__*/React.createElement("div", {
            style: {
              clear: 'both'
            }
          })), /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, Files && Files.length > 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('images-needs-uploading'))), /*#__PURE__*/React.createElement("div", {
            style: {
              marginLeft: '-0.5rem',
              marginRight: '-0.5em',
              display: 'flex'
            }
          }, Files.map(function (file) {
            return /*#__PURE__*/React.createElement("div", {
              key: file.lastModified,
              style: file.type.indexOf('image') > -1 ? {
                background: "url(".concat(file.dataURL, ")")
              } : {},
              className: "dropzone-file-preview ".concat(!file.accepted ? " not-accepted" : "", " ").concat(file.upload.progress > 0 ? ' upload-started' : ' not-started', " ").concat(file.type.indexOf('image') > -1 ? ' image' : '')
            }, /*#__PURE__*/React.createElement("div", {
              className: "file-name"
            }, /*#__PURE__*/React.createElement("div", {
              style: {
                flex: 1,
                maxWidth: 'calc(100% - 1rem)',
                wordWrap: 'break-word'
              }
            }, file.name + ' ', "(", file.size > 100000 ? Math.round(file.size / 1024 / 1024) + 'MB' : Math.round(file.size / 1024) + 'Kb', ")"), /*#__PURE__*/React.createElement("div", {
              onClick: function onClick(e) {
                _this2.onRemoveFile(file);
              },
              className: "file-delete-btn"
            }, /*#__PURE__*/React.createElement(Close, null))), file.accepted && file.size > 7500000 ? /*#__PURE__*/React.createElement("div", {
              className: "file-warning"
            }, /*#__PURE__*/React.createElement(Icon, {
              name: "Info_Blue"
            }), /*#__PURE__*/React.createElement("div", {
              style: {
                flex: 1
              }
            }, _this2.props.translate('size-warning'))) : null, !file.accepted ? /*#__PURE__*/React.createElement("div", {
              className: "file-warning"
            }, /*#__PURE__*/React.createElement(Icon, {
              name: "Alert"
            }), /*#__PURE__*/React.createElement("div", {
              style: {
                flex: 1
              }
            }, _this2.props.translate('file-too-big'))) : null, file.type.indexOf('image') > -1 ? /*#__PURE__*/React.createElement("div", {
              className: "overlay"
            }) : null);
          }))) : null), /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('important')), /*#__PURE__*/React.createElement(Checkbox, {
            value: _this2.state.important,
            checked: _this2.state.important,
            onChange: _this2.importantToggle,
            label: _this2.props.translate('is-this-event-important')
          })), /*#__PURE__*/React.createElement("div", {
            className: "form-row"
          }, /*#__PURE__*/React.createElement(DatePickerEvent, {
            onChange: _this2.onDateChange,
            values: initialValues,
            showEnd: important
          })), isEditing && initialValues.associatedFiles != null ? /*#__PURE__*/React.createElement("div", {
            className: "form-row",
            style: {
              marginTop: '1rem'
            }
          }, uploadedFiles != null && uploadedFiles.length > 0 && initialValues.associatedFiles.length > 0 ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("label", null, _this2.props.translate('images-attached'))), /*#__PURE__*/React.createElement("div", {
            style: {
              marginLeft: '-0.5rem',
              marginRight: '-0.5em',
              display: 'flex'
            }
          }, uploadedFiles.map(function (file, index) {
            return /*#__PURE__*/React.createElement(FileItem, {
              element: "div",
              file: file,
              key: file.id,
              className: "dropzone-file-preview ".concat(file.type.indexOf('image') > -1 ? ' image' : '')
            }, /*#__PURE__*/React.createElement("div", {
              className: "file-name"
            }, /*#__PURE__*/React.createElement("div", {
              style: {
                flex: 1
              }
            }, file.name), /*#__PURE__*/React.createElement("div", {
              onClick: function onClick(e) {
                _this2.removeFileFromDocument(file);
              },
              className: "file-delete-btn"
            }, /*#__PURE__*/React.createElement(Close, null))), file.type.indexOf('image') > -1 ? /*#__PURE__*/React.createElement("div", {
              className: "overlay"
            }) : null);
          }))) : null) : null, /*#__PURE__*/React.createElement("div", {
            className: "clearfix"
          }), /*#__PURE__*/React.createElement("div", {
            className: "form-divider"
          }), !passingGroup ? /*#__PURE__*/React.createElement("div", {
            className: "form-row spacing submit"
          }, _this2.props.translate('preschooldocument-form-studentgrouperror')) : null, /*#__PURE__*/React.createElement("div", {
            className: "form-row spacing submit"
          }, isEditing ? /*#__PURE__*/React.createElement(Button, {
            onClick: function onClick(e) {
              e.preventDefault();
              form.mutators.setStatusPublished();
              form.submit();
            },
            disabled: submitting || !valid || !passingGroup || _this2.state.important == true && _this2.state.dateStart == null
          }, _this2.props.translate('publish')) : /*#__PURE__*/React.createElement(Button, {
            disabled: submitting || !valid || !passingGroup || _this2.state.important == true && _this2.state.dateStart == null
          }, _this2.props.translate('publish')), isEditing && initialValues.status != "POST_DRAFT" ? null : /*#__PURE__*/React.createElement(Button, {
            onClick: function onClick(e) {
              e.preventDefault();
              form.mutators.setStatusDraft();
              form.submit();
            },
            type: "secondary",
            disabled: submitting || !valid || _this2.state.important == true && _this2.state.dateStart == null
          }, _this2.props.translate("save-draft")), /*#__PURE__*/React.createElement("div", {
            className: "align-right"
          }, /*#__PURE__*/React.createElement(Button, {
            onClick: _this2.onCancel,
            disabled: submitting,
            type: "secondary"
          }, _this2.props.translate('Cancel')))));
        }
      }));
    }
  }]);

  return Post;
}(Component);

_defineProperty(Post, "contextTypes", {
  router: PropTypes.object
});

_defineProperty(Post, "defaultProps", {
  selectMultipleSchools: false
});

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    sections: state.sections.educationGroups,
    mentorGroups: state.sections.mentorGroups,
    currentUser: state.user.currentUser,
    createdPost: state.Posts.createdPost,
    activePost: state.Posts.activePost
  };
}

export default withRouter(connect(mapStateToProps, {
  submit_post: submit_post,
  update_post: update_post,
  getSection: getSection,
  getSections: getSections,
  deletePostFile: deletePostFile,
  addError: addError,
  getMentorGroups: getMentorGroups
})(Post));